export const available_device_versions = [
    {id: 1, name: "MAC 1"},
    {id: 2, name: "MAC 2"},
    {id: 3, name: "MAC 3"}
];